import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { InvitationApi } from "../../../../services/Api/Organization/organizationTypes";
import { useAuth } from "../../../../services/Security/auth";
import { selectUser } from "../../../../services/users/selectors";
import LoginLayout from "../../components/LoginLayout";

interface Props {
	invitation: InvitationApi;
}

const InvitationForDifferentUser = ({ invitation }: Props) => {
	const { t } = useTranslation();
	const user = useSelector(selectUser);
	const auth = useAuth();

	const handleLogout = async () => {
		const loc = window.location.href;
		await auth.logout();
		window.location.href = loc;
	};

	return (
		<LoginLayout>
			<p>
				{t("modules.security.field.user_with_different_email.title", {
					name: invitation.organization.name,
					email: invitation.email,
					user: user.email,
				})}
			</p>
			<a href={"#"} className={"btn btn-default"} onClick={handleLogout}>
				{t("lib:common.action.logout")}
			</a>
		</LoginLayout>
	);
};

export default InvitationForDifferentUser;
